import { defineComponent as _defineComponent } from 'vue'
import { Vue } from "vue-property-decorator"
import { ref, computed, watch, onMounted } from 'vue'
import { useQuery } from '@vue/apollo-composable'
import { CircularLoader } from "@coredination/components"

import CustomerProjectView from "../customerproject/CustomerProjectView.vue"
import SelectCustomerProjectDialog from "@/components/dialogs/SelectCustomerProjectDialog.vue"
import CreateCustomerProjectDialog from "@/components/dialogs/CreateCustomerProjectDialog.vue"

import CustomerDetailQuery from "@/graphql/customer/customerdetail.graphql"

export default /*#__PURE__*/_defineComponent({
  __name: 'CustomerProjectList',
  props: {
    customerUuid: { type: String },
    customerProjectUuid: { type: String }
},
  setup(__props) {

const props = __props



const { result: customerDetailResult, refetch: refetchCustomerDetailResult, loading: loadingCustomerDetail } = useQuery(CustomerDetailQuery, () =>
    ({
        uuid: props.customerUuid
    }), {
        enabled: !!props.customerUuid
    }
)

const customer = computed(() => customerDetailResult.value?.customer ?? {})
const customerProjects = computed(() => customer?.value?.projects ?? [])
const activeTab = ref(1)
const selectingCustomerProject = ref(false)
const creatingCustomerProject = ref(false)
const customerProject = ref()
const customerProjectUuid = ref()
const loading = computed(() => { loadingCustomerDetail.value })
const iosWrapperClient = () => { Vue.prototype.$iosWrapperClient }

onMounted(() => {
    loadCustomerProject();
})

watch([customer], () => {
    loadCustomerProject();
})

const loadCustomerProject = () => {
    if (sessionStorage && sessionStorage.getItem('selectedCustomerProject')) {
        let projectUuid = sessionStorage.getItem('selectedCustomerProject') as string;
        if (customer?.value?.projects) {
            let loadedCustomerProject = customer.value.projects.find((project: any) => project.uuid === projectUuid);
            if (loadedCustomerProject) {
                customerProject.value = loadedCustomerProject;
                customerProjectUuid.value = loadedCustomerProject.uuid;
            } else delete sessionStorage.selectedCustomerProject;
        }
    }
}

const selectCustomerProject = (project: any) => {
    customerProject.value = project;
    customerProjectUuid.value = project ? project.uuid : null;
    if (sessionStorage) sessionStorage.setItem('selectedCustomerProject', customerProjectUuid.value);
}

const selectCreatedCustomerProject = (project: any) => {
    refetchCustomerDetailResult()
    selectCustomerProject(project)
}

const createCustomerProject = () => {
    selectingCustomerProject.value = false
    creatingCustomerProject.value = true
}

const options = computed(() => {
    if (!customerProjects.value) return [];
    return customerProjects.value.map((project: any) => {
        return {
            value: project.uuid,
            text: project.name
        }
    }) as any[];
})

return { __sfc: true,props, customerDetailResult, refetchCustomerDetailResult, loadingCustomerDetail, customer, customerProjects, activeTab, selectingCustomerProject, creatingCustomerProject, customerProject, customerProjectUuid, loading, iosWrapperClient, loadCustomerProject, selectCustomerProject, selectCreatedCustomerProject, createCustomerProject, options, CircularLoader, CustomerProjectView, SelectCustomerProjectDialog, CreateCustomerProjectDialog }
}

})